
export async function instantiate(imports={}, runInitializer=true) {
    imports['_cachedJsObjects_'] = imports['_cachedJsObjects_'] ?? new WeakMap();
    const cachedJsObjects = imports['_cachedJsObjects_'];

    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }


    imports['./skiko.mjs'] = imports['./skiko.mjs'] ?? await import('./skiko.mjs');
    imports['@js-joda/core'] = imports['@js-joda/core'] ?? await import('@js-joda/core');

    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.doubleToExternref' : (x) => x,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.kotlinUShortToJsNumberUnsafe' : (x) => x & 0xFFFF,
        'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsNumber_$external_class_instanceof' : (x) => typeof x === 'number',
        'kotlin.js.JsNumber_$external_class_get' : () => JsNumber,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'co.touchlab.kermit.consoleError' : (output) => console.error(output),
        'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
        'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
        'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
        'js.collections.JsMap_$external_fun' : (p0, isDefault0) => new Map(isDefault0 ? undefined : p0, ),
        'js.collections.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'js.collections.has_$external_fun' : (_this, p0) => _this.has(p0),
        'js.promise.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'js.promise.then_$external_fun' : (_this, p0, p1) => _this.then(p0, p1),
        'js.typedarrays.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'js.typedarrays.Float32Array_$external_fun' : (p0) => new Float32Array(p0),
        'js.typedarrays.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
        'js.typedarrays.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
        'web.dom.body_$external_prop_getter' : (_this) => _this.body,
        'web.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'web.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'web.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'web.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'web.dom.document_$external_prop_getter' : () => document,
        'web.gpu.Companion_$external_object_getInstance' : () => GPUCanvasContext,
        'web.gpu.GPUCanvasContext_$external_class_instanceof' : (x) => x instanceof GPUCanvasContext,
        'web.gpu.GPUCanvasContext_$external_class_get' : () => GPUCanvasContext,
        'web.html.height_$external_prop_getter' : (_this) => _this.height,
        'web.html.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'web.html.width_$external_prop_getter' : (_this) => _this.width,
        'web.html.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'web.html.getContext_$external_fun' : (_this, p0, p1, isDefault0) => _this.getContext(p0, isDefault0 ? undefined : p1, ),
        'web.html.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'web.html.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'web.html.hidden_$external_prop_setter' : (_this, v) => _this.hidden = v,
        'io.ygdrasil.webgpu.toULong' : (ref) => BigInt(ref),
        'io.ygdrasil.webgpu.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'io.ygdrasil.webgpu.window_$external_object_getInstance' : () => window,
        'io.ygdrasil.webgpu.getPreferredCanvasFormat_$external_fun' : (_this, ) => _this.getPreferredCanvasFormat(),
        'io.ygdrasil.webgpu.requestAdapter_$external_fun' : (_this, ) => _this.requestAdapter(),
        'io.ygdrasil.webgpu.requestAdapter_$external_fun_1' : (_this, p0) => _this.requestAdapter(p0),
        'io.ygdrasil.webgpu.gpu_$external_prop_getter' : (_this) => _this.gpu,
        'io.ygdrasil.webgpu.navigator_$external_object_getInstance' : () => navigator,
        'io.ygdrasil.webgpu.createJsObject' : () => ({ }),
        'io.ygdrasil.webgpu.canvas_$external_prop_getter' : (_this) => _this.canvas,
        'io.ygdrasil.webgpu.configure_$external_fun' : (_this, p0) => _this.configure(p0),
        'io.ygdrasil.webgpu.getCurrentTexture_$external_fun' : (_this, ) => _this.getCurrentTexture(),
        'io.ygdrasil.webgpu.createView_$external_fun' : (_this, ) => _this.createView(),
        'io.ygdrasil.webgpu.createView_$external_fun_1' : (_this, p0) => _this.createView(p0),
        'io.ygdrasil.webgpu.destroy_$external_fun' : (_this, ) => _this.destroy(),
        'io.ygdrasil.webgpu.device_$external_prop_setter' : (_this, v) => _this.device = v,
        'io.ygdrasil.webgpu.format_$external_prop_setter' : (_this, v) => _this.format = v,
        'io.ygdrasil.webgpu.usage_$external_prop_setter' : (_this, v) => _this.usage = v,
        'io.ygdrasil.webgpu.viewFormats_$external_prop_setter' : (_this, v) => _this.viewFormats = v,
        'io.ygdrasil.webgpu.colorSpace_$external_prop_setter' : (_this, v) => _this.colorSpace = v,
        'io.ygdrasil.webgpu.toneMapping_$external_prop_setter' : (_this, v) => _this.toneMapping = v,
        'io.ygdrasil.webgpu.alphaMode_$external_prop_setter' : (_this, v) => _this.alphaMode = v,
        'io.ygdrasil.webgpu.features_$external_prop_getter' : (_this) => _this.features,
        'io.ygdrasil.webgpu.limits_$external_prop_getter' : (_this) => _this.limits,
        'io.ygdrasil.webgpu.queue_$external_prop_getter' : (_this) => _this.queue,
        'io.ygdrasil.webgpu.destroy_$external_fun_1' : (_this, ) => _this.destroy(),
        'io.ygdrasil.webgpu.createBuffer_$external_fun' : (_this, p0) => _this.createBuffer(p0),
        'io.ygdrasil.webgpu.createTexture_$external_fun' : (_this, p0) => _this.createTexture(p0),
        'io.ygdrasil.webgpu.createSampler_$external_fun' : (_this, ) => _this.createSampler(),
        'io.ygdrasil.webgpu.createSampler_$external_fun_1' : (_this, p0) => _this.createSampler(p0),
        'io.ygdrasil.webgpu.createBindGroupLayout_$external_fun' : (_this, p0) => _this.createBindGroupLayout(p0),
        'io.ygdrasil.webgpu.createPipelineLayout_$external_fun' : (_this, p0) => _this.createPipelineLayout(p0),
        'io.ygdrasil.webgpu.createBindGroup_$external_fun' : (_this, p0) => _this.createBindGroup(p0),
        'io.ygdrasil.webgpu.createShaderModule_$external_fun' : (_this, p0) => _this.createShaderModule(p0),
        'io.ygdrasil.webgpu.createRenderPipeline_$external_fun' : (_this, p0) => _this.createRenderPipeline(p0),
        'io.ygdrasil.webgpu.createCommandEncoder_$external_fun' : (_this, ) => _this.createCommandEncoder(),
        'io.ygdrasil.webgpu.createCommandEncoder_$external_fun_1' : (_this, p0) => _this.createCommandEncoder(p0),
        'io.ygdrasil.webgpu.mode_$external_prop_setter' : (_this, v) => _this.mode = v,
        'io.ygdrasil.webgpu.submit_$external_fun' : (_this, p0) => _this.submit(p0),
        'io.ygdrasil.webgpu.writeBuffer_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.writeBuffer(p0, p1, p2, p3, p4),
        'io.ygdrasil.webgpu.writeTexture_$external_fun' : (_this, p0, p1, p2, p3) => _this.writeTexture(p0, p1, p2, p3),
        'io.ygdrasil.webgpu.destroy_$external_fun_2' : (_this, ) => _this.destroy(),
        'io.ygdrasil.webgpu.features_$external_prop_getter_1' : (_this) => _this.features,
        'io.ygdrasil.webgpu.limits_$external_prop_getter_1' : (_this) => _this.limits,
        'io.ygdrasil.webgpu.requestDevice_$external_fun' : (_this, ) => _this.requestDevice(),
        'io.ygdrasil.webgpu.requestDevice_$external_fun_1' : (_this, p0) => _this.requestDevice(p0),
        'io.ygdrasil.webgpu.maxTextureDimension1D_$external_prop_getter' : (_this) => _this.maxTextureDimension1D,
        'io.ygdrasil.webgpu.maxTextureDimension2D_$external_prop_getter' : (_this) => _this.maxTextureDimension2D,
        'io.ygdrasil.webgpu.maxTextureDimension3D_$external_prop_getter' : (_this) => _this.maxTextureDimension3D,
        'io.ygdrasil.webgpu.maxTextureArrayLayers_$external_prop_getter' : (_this) => _this.maxTextureArrayLayers,
        'io.ygdrasil.webgpu.maxBindGroups_$external_prop_getter' : (_this) => _this.maxBindGroups,
        'io.ygdrasil.webgpu.maxBindGroupsPlusVertexBuffers_$external_prop_getter' : (_this) => _this.maxBindGroupsPlusVertexBuffers,
        'io.ygdrasil.webgpu.maxBindingsPerBindGroup_$external_prop_getter' : (_this) => _this.maxBindingsPerBindGroup,
        'io.ygdrasil.webgpu.maxDynamicUniformBuffersPerPipelineLayout_$external_prop_getter' : (_this) => _this.maxDynamicUniformBuffersPerPipelineLayout,
        'io.ygdrasil.webgpu.maxDynamicStorageBuffersPerPipelineLayout_$external_prop_getter' : (_this) => _this.maxDynamicStorageBuffersPerPipelineLayout,
        'io.ygdrasil.webgpu.maxSampledTexturesPerShaderStage_$external_prop_getter' : (_this) => _this.maxSampledTexturesPerShaderStage,
        'io.ygdrasil.webgpu.maxSamplersPerShaderStage_$external_prop_getter' : (_this) => _this.maxSamplersPerShaderStage,
        'io.ygdrasil.webgpu.maxStorageBuffersPerShaderStage_$external_prop_getter' : (_this) => _this.maxStorageBuffersPerShaderStage,
        'io.ygdrasil.webgpu.maxStorageTexturesPerShaderStage_$external_prop_getter' : (_this) => _this.maxStorageTexturesPerShaderStage,
        'io.ygdrasil.webgpu.maxUniformBuffersPerShaderStage_$external_prop_getter' : (_this) => _this.maxUniformBuffersPerShaderStage,
        'io.ygdrasil.webgpu.maxUniformBufferBindingSize_$external_prop_getter' : (_this) => _this.maxUniformBufferBindingSize,
        'io.ygdrasil.webgpu.maxStorageBufferBindingSize_$external_prop_getter' : (_this) => _this.maxStorageBufferBindingSize,
        'io.ygdrasil.webgpu.minUniformBufferOffsetAlignment_$external_prop_getter' : (_this) => _this.minUniformBufferOffsetAlignment,
        'io.ygdrasil.webgpu.minStorageBufferOffsetAlignment_$external_prop_getter' : (_this) => _this.minStorageBufferOffsetAlignment,
        'io.ygdrasil.webgpu.maxVertexBuffers_$external_prop_getter' : (_this) => _this.maxVertexBuffers,
        'io.ygdrasil.webgpu.maxBufferSize_$external_prop_getter' : (_this) => _this.maxBufferSize,
        'io.ygdrasil.webgpu.maxVertexAttributes_$external_prop_getter' : (_this) => _this.maxVertexAttributes,
        'io.ygdrasil.webgpu.maxVertexBufferArrayStride_$external_prop_getter' : (_this) => _this.maxVertexBufferArrayStride,
        'io.ygdrasil.webgpu.maxInterStageShaderVariables_$external_prop_getter' : (_this) => _this.maxInterStageShaderVariables,
        'io.ygdrasil.webgpu.maxColorAttachments_$external_prop_getter' : (_this) => _this.maxColorAttachments,
        'io.ygdrasil.webgpu.maxColorAttachmentBytesPerSample_$external_prop_getter' : (_this) => _this.maxColorAttachmentBytesPerSample,
        'io.ygdrasil.webgpu.maxComputeWorkgroupStorageSize_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupStorageSize,
        'io.ygdrasil.webgpu.maxComputeInvocationsPerWorkgroup_$external_prop_getter' : (_this) => _this.maxComputeInvocationsPerWorkgroup,
        'io.ygdrasil.webgpu.maxComputeWorkgroupSizeX_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeX,
        'io.ygdrasil.webgpu.maxComputeWorkgroupSizeY_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeY,
        'io.ygdrasil.webgpu.maxComputeWorkgroupSizeZ_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupSizeZ,
        'io.ygdrasil.webgpu.maxComputeWorkgroupsPerDimension_$external_prop_getter' : (_this) => _this.maxComputeWorkgroupsPerDimension,
        'io.ygdrasil.webgpu.requiredFeatures_$external_prop_setter' : (_this, v) => _this.requiredFeatures = v,
        'io.ygdrasil.webgpu.requiredLimits_$external_prop_setter' : (_this, v) => _this.requiredLimits = v,
        'io.ygdrasil.webgpu.defaultQueue_$external_prop_setter' : (_this, v) => _this.defaultQueue = v,
        'io.ygdrasil.webgpu.featureLevel_$external_prop_setter' : (_this, v) => _this.featureLevel = v,
        'io.ygdrasil.webgpu.powerPreference_$external_prop_setter' : (_this, v) => _this.powerPreference = v,
        'io.ygdrasil.webgpu.forceFallbackAdapter_$external_prop_setter' : (_this, v) => _this.forceFallbackAdapter = v,
        'io.ygdrasil.webgpu.xrCompatible_$external_prop_setter' : (_this, v) => _this.xrCompatible = v,
        'io.ygdrasil.webgpu.format_$external_prop_setter_1' : (_this, v) => _this.format = v,
        'io.ygdrasil.webgpu.dimension_$external_prop_setter' : (_this, v) => _this.dimension = v,
        'io.ygdrasil.webgpu.aspect_$external_prop_setter' : (_this, v) => _this.aspect = v,
        'io.ygdrasil.webgpu.baseMipLevel_$external_prop_setter' : (_this, v) => _this.baseMipLevel = v,
        'io.ygdrasil.webgpu.mipLevelCount_$external_prop_setter' : (_this, v) => _this.mipLevelCount = v,
        'io.ygdrasil.webgpu.baseArrayLayer_$external_prop_setter' : (_this, v) => _this.baseArrayLayer = v,
        'io.ygdrasil.webgpu.arrayLayerCount_$external_prop_setter' : (_this, v) => _this.arrayLayerCount = v,
        'io.ygdrasil.webgpu.beginRenderPass_$external_fun' : (_this, p0) => _this.beginRenderPass(p0),
        'io.ygdrasil.webgpu.finish_$external_fun' : (_this, ) => _this.finish(),
        'io.ygdrasil.webgpu.finish_$external_fun_1' : (_this, p0) => _this.finish(p0),
        'io.ygdrasil.webgpu.code_$external_prop_setter' : (_this, v) => _this.code = v,
        'io.ygdrasil.webgpu.compilationHints_$external_prop_setter' : (_this, v) => _this.compilationHints = v,
        'io.ygdrasil.webgpu.bindGroupLayouts_$external_prop_setter' : (_this, v) => _this.bindGroupLayouts = v,
        'io.ygdrasil.webgpu.vertex_$external_prop_setter' : (_this, v) => _this.vertex = v,
        'io.ygdrasil.webgpu.primitive_$external_prop_setter' : (_this, v) => _this.primitive = v,
        'io.ygdrasil.webgpu.depthStencil_$external_prop_setter' : (_this, v) => _this.depthStencil = v,
        'io.ygdrasil.webgpu.multisample_$external_prop_setter' : (_this, v) => _this.multisample = v,
        'io.ygdrasil.webgpu.fragment_$external_prop_setter' : (_this, v) => _this.fragment = v,
        'io.ygdrasil.webgpu.size_$external_prop_setter' : (_this, v) => _this.size = v,
        'io.ygdrasil.webgpu.usage_$external_prop_setter_1' : (_this, v) => _this.usage = v,
        'io.ygdrasil.webgpu.mappedAtCreation_$external_prop_setter' : (_this, v) => _this.mappedAtCreation = v,
        'io.ygdrasil.webgpu.size_$external_prop_setter_1' : (_this, v) => _this.size = v,
        'io.ygdrasil.webgpu.mipLevelCount_$external_prop_setter_1' : (_this, v) => _this.mipLevelCount = v,
        'io.ygdrasil.webgpu.sampleCount_$external_prop_setter' : (_this, v) => _this.sampleCount = v,
        'io.ygdrasil.webgpu.dimension_$external_prop_setter_1' : (_this, v) => _this.dimension = v,
        'io.ygdrasil.webgpu.format_$external_prop_setter_2' : (_this, v) => _this.format = v,
        'io.ygdrasil.webgpu.usage_$external_prop_setter_2' : (_this, v) => _this.usage = v,
        'io.ygdrasil.webgpu.viewFormats_$external_prop_setter_1' : (_this, v) => _this.viewFormats = v,
        'io.ygdrasil.webgpu.layout_$external_prop_setter' : (_this, v) => _this.layout = v,
        'io.ygdrasil.webgpu.entries_$external_prop_setter' : (_this, v) => _this.entries = v,
        'io.ygdrasil.webgpu.addressModeU_$external_prop_setter' : (_this, v) => _this.addressModeU = v,
        'io.ygdrasil.webgpu.addressModeV_$external_prop_setter' : (_this, v) => _this.addressModeV = v,
        'io.ygdrasil.webgpu.addressModeW_$external_prop_setter' : (_this, v) => _this.addressModeW = v,
        'io.ygdrasil.webgpu.magFilter_$external_prop_setter' : (_this, v) => _this.magFilter = v,
        'io.ygdrasil.webgpu.minFilter_$external_prop_setter' : (_this, v) => _this.minFilter = v,
        'io.ygdrasil.webgpu.mipmapFilter_$external_prop_setter' : (_this, v) => _this.mipmapFilter = v,
        'io.ygdrasil.webgpu.lodMinClamp_$external_prop_setter' : (_this, v) => _this.lodMinClamp = v,
        'io.ygdrasil.webgpu.lodMaxClamp_$external_prop_setter' : (_this, v) => _this.lodMaxClamp = v,
        'io.ygdrasil.webgpu.compare_$external_prop_setter' : (_this, v) => _this.compare = v,
        'io.ygdrasil.webgpu.maxAnisotropy_$external_prop_setter' : (_this, v) => _this.maxAnisotropy = v,
        'io.ygdrasil.webgpu.entries_$external_prop_setter_1' : (_this, v) => _this.entries = v,
        'io.ygdrasil.webgpu.message_$external_prop_getter' : (_this) => _this.message,
        'io.ygdrasil.webgpu.texture_$external_prop_setter' : (_this, v) => _this.texture = v,
        'io.ygdrasil.webgpu.mipLevel_$external_prop_setter' : (_this, v) => _this.mipLevel = v,
        'io.ygdrasil.webgpu.origin_$external_prop_setter' : (_this, v) => _this.origin = v,
        'io.ygdrasil.webgpu.aspect_$external_prop_setter_1' : (_this, v) => _this.aspect = v,
        'io.ygdrasil.webgpu.offset_$external_prop_setter' : (_this, v) => _this.offset = v,
        'io.ygdrasil.webgpu.bytesPerRow_$external_prop_setter' : (_this, v) => _this.bytesPerRow = v,
        'io.ygdrasil.webgpu.rowsPerImage_$external_prop_setter' : (_this, v) => _this.rowsPerImage = v,
        'io.ygdrasil.webgpu.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'io.ygdrasil.webgpu.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'io.ygdrasil.webgpu.depthOrArrayLayers_$external_prop_setter' : (_this, v) => _this.depthOrArrayLayers = v,
        'io.ygdrasil.webgpu.end_$external_fun' : (_this, ) => _this.end(),
        'io.ygdrasil.webgpu.colorAttachments_$external_prop_setter' : (_this, v) => _this.colorAttachments = v,
        'io.ygdrasil.webgpu.depthStencilAttachment_$external_prop_setter' : (_this, v) => _this.depthStencilAttachment = v,
        'io.ygdrasil.webgpu.maxDrawCount_$external_prop_setter' : (_this, v) => _this.maxDrawCount = v,
        'io.ygdrasil.webgpu.entryPoint_$external_prop_setter' : (_this, v) => _this.entryPoint = v,
        'io.ygdrasil.webgpu.layout_$external_prop_setter_1' : (_this, v) => _this.layout = v,
        'io.ygdrasil.webgpu.buffers_$external_prop_setter' : (_this, v) => _this.buffers = v,
        'io.ygdrasil.webgpu.topology_$external_prop_setter' : (_this, v) => _this.topology = v,
        'io.ygdrasil.webgpu.stripIndexFormat_$external_prop_setter' : (_this, v) => _this.stripIndexFormat = v,
        'io.ygdrasil.webgpu.frontFace_$external_prop_setter' : (_this, v) => _this.frontFace = v,
        'io.ygdrasil.webgpu.cullMode_$external_prop_setter' : (_this, v) => _this.cullMode = v,
        'io.ygdrasil.webgpu.unclippedDepth_$external_prop_setter' : (_this, v) => _this.unclippedDepth = v,
        'io.ygdrasil.webgpu.format_$external_prop_setter_3' : (_this, v) => _this.format = v,
        'io.ygdrasil.webgpu.depthWriteEnabled_$external_prop_setter' : (_this, v) => _this.depthWriteEnabled = v,
        'io.ygdrasil.webgpu.depthCompare_$external_prop_setter' : (_this, v) => _this.depthCompare = v,
        'io.ygdrasil.webgpu.stencilFront_$external_prop_setter' : (_this, v) => _this.stencilFront = v,
        'io.ygdrasil.webgpu.stencilBack_$external_prop_setter' : (_this, v) => _this.stencilBack = v,
        'io.ygdrasil.webgpu.stencilReadMask_$external_prop_setter' : (_this, v) => _this.stencilReadMask = v,
        'io.ygdrasil.webgpu.stencilWriteMask_$external_prop_setter' : (_this, v) => _this.stencilWriteMask = v,
        'io.ygdrasil.webgpu.depthBias_$external_prop_setter' : (_this, v) => _this.depthBias = v,
        'io.ygdrasil.webgpu.depthBiasSlopeScale_$external_prop_setter' : (_this, v) => _this.depthBiasSlopeScale = v,
        'io.ygdrasil.webgpu.depthBiasClamp_$external_prop_setter' : (_this, v) => _this.depthBiasClamp = v,
        'io.ygdrasil.webgpu.targets_$external_prop_setter' : (_this, v) => _this.targets = v,
        'io.ygdrasil.webgpu.count_$external_prop_setter' : (_this, v) => _this.count = v,
        'io.ygdrasil.webgpu.mask_$external_prop_setter' : (_this, v) => _this.mask = v,
        'io.ygdrasil.webgpu.alphaToCoverageEnabled_$external_prop_setter' : (_this, v) => _this.alphaToCoverageEnabled = v,
        'io.ygdrasil.webgpu.arrayStride_$external_prop_setter' : (_this, v) => _this.arrayStride = v,
        'io.ygdrasil.webgpu.stepMode_$external_prop_setter' : (_this, v) => _this.stepMode = v,
        'io.ygdrasil.webgpu.attributes_$external_prop_setter' : (_this, v) => _this.attributes = v,
        'io.ygdrasil.webgpu.compare_$external_prop_setter_1' : (_this, v) => _this.compare = v,
        'io.ygdrasil.webgpu.failOp_$external_prop_setter' : (_this, v) => _this.failOp = v,
        'io.ygdrasil.webgpu.depthFailOp_$external_prop_setter' : (_this, v) => _this.depthFailOp = v,
        'io.ygdrasil.webgpu.passOp_$external_prop_setter' : (_this, v) => _this.passOp = v,
        'io.ygdrasil.webgpu.format_$external_prop_setter_4' : (_this, v) => _this.format = v,
        'io.ygdrasil.webgpu.blend_$external_prop_setter' : (_this, v) => _this.blend = v,
        'io.ygdrasil.webgpu.writeMask_$external_prop_setter' : (_this, v) => _this.writeMask = v,
        'io.ygdrasil.webgpu.format_$external_prop_setter_5' : (_this, v) => _this.format = v,
        'io.ygdrasil.webgpu.offset_$external_prop_setter_1' : (_this, v) => _this.offset = v,
        'io.ygdrasil.webgpu.shaderLocation_$external_prop_setter' : (_this, v) => _this.shaderLocation = v,
        'io.ygdrasil.webgpu.color_$external_prop_setter' : (_this, v) => _this.color = v,
        'io.ygdrasil.webgpu.alpha_$external_prop_setter' : (_this, v) => _this.alpha = v,
        'io.ygdrasil.webgpu.operation_$external_prop_setter' : (_this, v) => _this.operation = v,
        'io.ygdrasil.webgpu.srcFactor_$external_prop_setter' : (_this, v) => _this.srcFactor = v,
        'io.ygdrasil.webgpu.dstFactor_$external_prop_setter' : (_this, v) => _this.dstFactor = v,
        'io.ygdrasil.webgpu.module_$external_prop_setter' : (_this, v) => _this.module = v,
        'io.ygdrasil.webgpu.entryPoint_$external_prop_setter_1' : (_this, v) => _this.entryPoint = v,
        'io.ygdrasil.webgpu.binding_$external_prop_setter' : (_this, v) => _this.binding = v,
        'io.ygdrasil.webgpu.resource_$external_prop_setter' : (_this, v) => _this.resource = v,
        'io.ygdrasil.webgpu.buffer_$external_prop_setter' : (_this, v) => _this.buffer = v,
        'io.ygdrasil.webgpu.offset_$external_prop_setter_2' : (_this, v) => _this.offset = v,
        'io.ygdrasil.webgpu.size_$external_prop_setter_2' : (_this, v) => _this.size = v,
        'io.ygdrasil.webgpu.binding_$external_prop_setter_1' : (_this, v) => _this.binding = v,
        'io.ygdrasil.webgpu.visibility_$external_prop_setter' : (_this, v) => _this.visibility = v,
        'io.ygdrasil.webgpu.buffer_$external_prop_setter_1' : (_this, v) => _this.buffer = v,
        'io.ygdrasil.webgpu.sampler_$external_prop_setter' : (_this, v) => _this.sampler = v,
        'io.ygdrasil.webgpu.texture_$external_prop_setter_1' : (_this, v) => _this.texture = v,
        'io.ygdrasil.webgpu.storageTexture_$external_prop_setter' : (_this, v) => _this.storageTexture = v,
        'io.ygdrasil.webgpu.type_$external_prop_setter' : (_this, v) => _this.type = v,
        'io.ygdrasil.webgpu.hasDynamicOffset_$external_prop_setter' : (_this, v) => _this.hasDynamicOffset = v,
        'io.ygdrasil.webgpu.minBindingSize_$external_prop_setter' : (_this, v) => _this.minBindingSize = v,
        'io.ygdrasil.webgpu.type_$external_prop_setter_1' : (_this, v) => _this.type = v,
        'io.ygdrasil.webgpu.sampleType_$external_prop_setter' : (_this, v) => _this.sampleType = v,
        'io.ygdrasil.webgpu.viewDimension_$external_prop_setter' : (_this, v) => _this.viewDimension = v,
        'io.ygdrasil.webgpu.multisampled_$external_prop_setter' : (_this, v) => _this.multisampled = v,
        'io.ygdrasil.webgpu.access_$external_prop_setter' : (_this, v) => _this.access = v,
        'io.ygdrasil.webgpu.format_$external_prop_setter_6' : (_this, v) => _this.format = v,
        'io.ygdrasil.webgpu.viewDimension_$external_prop_setter_1' : (_this, v) => _this.viewDimension = v,
        'io.ygdrasil.webgpu.x_$external_prop_setter' : (_this, v) => _this.x = v,
        'io.ygdrasil.webgpu.y_$external_prop_setter' : (_this, v) => _this.y = v,
        'io.ygdrasil.webgpu.z_$external_prop_setter' : (_this, v) => _this.z = v,
        'io.ygdrasil.webgpu.r_$external_prop_setter' : (_this, v) => _this.r = v,
        'io.ygdrasil.webgpu.g_$external_prop_setter' : (_this, v) => _this.g = v,
        'io.ygdrasil.webgpu.b_$external_prop_setter' : (_this, v) => _this.b = v,
        'io.ygdrasil.webgpu.a_$external_prop_setter' : (_this, v) => _this.a = v,
        'io.ygdrasil.webgpu.view_$external_prop_setter' : (_this, v) => _this.view = v,
        'io.ygdrasil.webgpu.depthSlice_$external_prop_setter' : (_this, v) => _this.depthSlice = v,
        'io.ygdrasil.webgpu.resolveTarget_$external_prop_setter' : (_this, v) => _this.resolveTarget = v,
        'io.ygdrasil.webgpu.clearValue_$external_prop_setter' : (_this, v) => _this.clearValue = v,
        'io.ygdrasil.webgpu.loadOp_$external_prop_setter' : (_this, v) => _this.loadOp = v,
        'io.ygdrasil.webgpu.storeOp_$external_prop_setter' : (_this, v) => _this.storeOp = v,
        'io.ygdrasil.webgpu.view_$external_prop_setter_1' : (_this, v) => _this.view = v,
        'io.ygdrasil.webgpu.depthClearValue_$external_prop_setter' : (_this, v) => _this.depthClearValue = v,
        'io.ygdrasil.webgpu.depthLoadOp_$external_prop_setter' : (_this, v) => _this.depthLoadOp = v,
        'io.ygdrasil.webgpu.depthStoreOp_$external_prop_setter' : (_this, v) => _this.depthStoreOp = v,
        'io.ygdrasil.webgpu.depthReadOnly_$external_prop_setter' : (_this, v) => _this.depthReadOnly = v,
        'io.ygdrasil.webgpu.stencilClearValue_$external_prop_setter' : (_this, v) => _this.stencilClearValue = v,
        'io.ygdrasil.webgpu.stencilLoadOp_$external_prop_setter' : (_this, v) => _this.stencilLoadOp = v,
        'io.ygdrasil.webgpu.stencilStoreOp_$external_prop_setter' : (_this, v) => _this.stencilStoreOp = v,
        'io.ygdrasil.webgpu.stencilReadOnly_$external_prop_setter' : (_this, v) => _this.stencilReadOnly = v,
        'io.ygdrasil.webgpu.label_$external_prop_setter' : (_this, v) => _this.label = v,
        'io.ygdrasil.webgpu.layout_$external_prop_setter_2' : (_this, v) => _this.layout = v,
        'io.ygdrasil.webgpu.setBindGroup_$external_fun' : (_this, p0, p1, p2) => _this.setBindGroup(p0, p1, p2),
        'io.ygdrasil.webgpu.setPipeline_$external_fun' : (_this, p0) => _this.setPipeline(p0),
        'io.ygdrasil.webgpu.setIndexBuffer_$external_fun' : (_this, p0, p1, p2) => _this.setIndexBuffer(p0, p1, p2),
        'io.ygdrasil.webgpu.setIndexBuffer_$external_fun_1' : (_this, p0, p1, p2, p3) => _this.setIndexBuffer(p0, p1, p2, p3),
        'io.ygdrasil.webgpu.setVertexBuffer_$external_fun' : (_this, p0, p1, p2) => _this.setVertexBuffer(p0, p1, p2),
        'io.ygdrasil.webgpu.setVertexBuffer_$external_fun_1' : (_this, p0, p1, p2, p3) => _this.setVertexBuffer(p0, p1, p2, p3),
        'io.ygdrasil.webgpu.draw_$external_fun' : (_this, p0, p1, p2, p3) => _this.draw(p0, p1, p2, p3),
        'io.ygdrasil.webgpu.drawIndexed_$external_fun' : (_this, p0, p1, p2, p3, p4) => _this.drawIndexed(p0, p1, p2, p3, p4),
        'io.ygdrasil.webgpu.toJsNumber' : (x) => x,
        'io.ygdrasil.webgpu.toJsNumber_1' : (x) => x,
        'io.ygdrasil.webgpu.toJsNumber_2' : (x) => x,
        'io.ygdrasil.webgpu.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'io.ygdrasil.webgpu.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'io.ygdrasil.webgpu.error_$external_prop_getter' : (_this) => _this.error,
        'io.ygdrasil.webgpu.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'io.ygdrasil.webgpu.Event_$external_class_get' : () => Event,
        'io.ygdrasil.webgpu.mapper.isGPUValidationError' : (error) => error instanceof GPUValidationError,
        'io.ygdrasil.webgpu.mapper.isGPUInternalError' : (error) => error instanceof GPUInternalError,
        'io.ygdrasil.webgpu.mapper.isGPUOutOfMemoryError' : (error) => error instanceof GPUOutOfMemoryError,
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'com.hyeonslab.prism.assets.createInt8Array' : (len) => new Int8Array(len),
        'com.hyeonslab.prism.assets.int8ArraySet4Bytes' : (arr, i, b0, b1, b2, b3) => { arr[i]=b0; arr[i+1]=b1; arr[i+2]=b2; arr[i+3]=b3; },
        'com.hyeonslab.prism.assets.int8ArraySetByte' : (arr, i, b) => { arr[i] = b; },
        'com.hyeonslab.prism.assets.decodeImageBitmapJs' : (bytes, onSuccess, onError) => {
          const blob = new Blob([bytes]);
          createImageBitmap(blob, { premultiplyAlpha: 'none' })
            .then(bmp => {
              const w = bmp.width, h = bmp.height;
              const canvas = new OffscreenCanvas(w, h);
              const ctx = canvas.getContext('2d');
              ctx.drawImage(bmp, 0, 0);
              bmp.close();
              const imgData = ctx.getImageData(0, 0, w, h);
              // Return the underlying ArrayBuffer directly (zero-copy to wgpu4k ArrayBuffer.wrap).
              // Use .slice() to ensure byteOffset=0 in case the UA returns a non-zero-offset view.
              const clamped = imgData.data;
              const buf = clamped.buffer.slice(clamped.byteOffset, clamped.byteOffset + clamped.byteLength);
              onSuccess(w, h, buf);
            })
            .catch(e => onError(String(e)));
        },
        'com.hyeonslab.prism.assets.__convertKotlinClosureToJsClosure_((Int,Int,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Int,Int,Js)->Unit)'](f, p0, p1, p2)),
        'com.hyeonslab.prism.assets.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
        'com.hyeonslab.prism.assets.decodeFromJsBufferJs' : (jsBuffer, offset, length, onSuccess, onError) => {
          const slice = jsBuffer.slice(offset, offset + length);
          const blob = new Blob([slice]);
          createImageBitmap(blob, { premultiplyAlpha: 'none' })
            .then(bmp => {
              const w = bmp.width, h = bmp.height;
              const canvas = new OffscreenCanvas(w, h);
              const ctx = canvas.getContext('2d');
              ctx.drawImage(bmp, 0, 0);
              bmp.close();
              const imgData = ctx.getImageData(0, 0, w, h);
              const clamped = imgData.data;
              const buf = clamped.buffer.slice(clamped.byteOffset, clamped.byteOffset + clamped.byteLength);
              onSuccess(w, h, buf);
            })
            .catch(e => onError(String(e)));
        },
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'com.hyeonslab.prism.widget.jsInstallPointerDrag' : (canvas, onDelta) => {
          canvas.style.touchAction = 'pan-x pan-y'; // single finger scrolls; 2 fingers orbit
        
          const hint = document.createElement('div');
          hint.textContent = 'Use two fingers to rotate';
          hint.style.cssText =
            'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);' +
            'background:rgba(0,0,0,0.52);color:#fff;font:13px/1 -apple-system,sans-serif;' +
            'padding:8px 16px;border-radius:20px;pointer-events:none;' +
            'opacity:0;transition:opacity 0.2s;white-space:nowrap;z-index:20;';
          (canvas.parentElement || document.body).appendChild(hint);
          let hintTimer = null;
          let hintShowTimer = null;
          const showHint = () => {
            clearTimeout(hintTimer);
            hint.style.opacity = '1';
            hintTimer = setTimeout(() => { hint.style.opacity = '0'; }, 1400);
          };
          // Schedule hint with a brief delay so it can be cancelled if a second finger arrives.
          const scheduleHint = () => {
            clearTimeout(hintShowTimer);
            hintShowTimer = setTimeout(showHint, 80);
          };
          const cancelHint = () => { clearTimeout(hintShowTimer); };
        
          const touches = new Set(); // active touch pointer IDs
          let orbitId = null, lastX = 0, lastY = 0;
        
          canvas.addEventListener('pointerdown', e => {
            if (e.pointerType === 'touch') {
              touches.add(e.pointerId);
              if (touches.size === 1) { scheduleHint(); return; } // single finger — let browser scroll
              if (touches.size >= 2 && orbitId === null) {    // second finger — start orbit
                cancelHint(); // user has two fingers; suppress the hint
                orbitId = e.pointerId; lastX = e.clientX; lastY = e.clientY;
                canvas.setPointerCapture(e.pointerId); e.preventDefault();
              }
            } else {
              orbitId = e.pointerId; lastX = e.clientX; lastY = e.clientY;
              canvas.setPointerCapture(e.pointerId); e.preventDefault();
            }
          }, { passive: false });
        
          canvas.addEventListener('pointermove', e => {
            if (e.pointerId !== orbitId) return;
            onDelta(e.clientX - lastX, e.clientY - lastY);
            lastX = e.clientX; lastY = e.clientY;
            e.preventDefault();
          }, { passive: false });
        
          canvas.addEventListener('pointerup', e => {
            if (e.pointerType === 'touch') { touches.delete(e.pointerId); if (touches.size === 0) cancelHint(); }
            if (e.pointerId === orbitId) {
              orbitId = null;
              try { canvas.releasePointerCapture(e.pointerId); } catch (_) {}
            }
          });
          canvas.addEventListener('pointercancel', e => {
            if (e.pointerType === 'touch') { touches.delete(e.pointerId); if (touches.size === 0) cancelHint(); }
            if (e.pointerId === orbitId) orbitId = null;
          });
        },
        'com.hyeonslab.prism.widget.__convertKotlinClosureToJsClosure_((Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Double,Double)->Unit)'](f, p0, p1)),
        'com.hyeonslab.prism.widget.jsInstallResizeObserver' : (canvas, onResize) => {
          const ro = new ResizeObserver(() => {
            const w = Math.floor(canvas.clientWidth);
            const h = Math.floor(canvas.clientHeight);
            if (w > 0 && h > 0) { canvas.width = w; canvas.height = h; onResize(w, h); }
          });
          ro.observe(canvas);
        },
        'com.hyeonslab.prism.widget.__convertKotlinClosureToJsClosure_((Int,Int)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Int,Int)->Unit)'](f, p0, p1)),
        'com.hyeonslab.prism.widget.jsOnBeforeUnload' : (callback) => window.addEventListener('beforeunload', callback),
        'com.hyeonslab.prism.widget.jsNow' : () => performance.now(),
        'com.hyeonslab.prism.widget.jsNotifyFirstFrameReady' : () => { var f = window.prismHideLoading; if (f) f(); },
        'com.hyeonslab.prism.widget.jsNextFrame' : (callback) => requestAnimationFrame((t) => callback(t)),
        'com.hyeonslab.prism.widget.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'com.hyeonslab.prism.widget.jsGetCanvasById' : (id) => {
          var el = document.getElementById(id);
          if (el && !(el instanceof HTMLCanvasElement)) {
            throw new Error('Element "' + id + '" is not a canvas element');
          }
          return el;
        },
        'com.hyeonslab.prism.widget.jsWindowWidth' : () => window.innerWidth,
        'com.hyeonslab.prism.widget.jsWindowHeight' : () => window.innerHeight,
        'com.hyeonslab.prism.widget.jsSetCanvasSize' : (canvas, w, h) => { canvas.width = w; canvas.height = h; },
        'com.hyeonslab.prism.widget.jsFetchWithBuffer' : (url, onSuccess, onError) => {
          fetch(url)
            .then(r => r.arrayBuffer())
            .then(buf => onSuccess(new Int8Array(buf), buf))
            .catch(e => onError(String(e)));
        },
        'com.hyeonslab.prism.widget.__convertKotlinClosureToJsClosure_((Js,Js)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Js,Js)->Unit)'](f, p0, p1)),
        'com.hyeonslab.prism.widget.jsArrayLength' : (arr) => arr.length,
        'com.hyeonslab.prism.widget.jsReadInt32LE' : (arr, i) => (arr[i] & 0xFF) | ((arr[i+1] & 0xFF) << 8) | ((arr[i+2] & 0xFF) << 16) | ((arr[i+3] & 0xFF) << 24),
        'com.hyeonslab.prism.widget.jsArrayByte' : (arr, i) => arr[i],
        'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
        'kotlinx.io.getPlatformName' : 
            () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
        ,
        'kotlinx.io.node.persistModule' : 
            (globalThis.module = (typeof process !== 'undefined') && (process.release.name === 'node') ?
                await import(/* webpackIgnore: true */'node:module') : void 0, () => {})
        ,
        'kotlinx.io.node.getRequire' : () => { 
            const importMeta = import.meta;
            return globalThis.module.default.createRequire(importMeta.url);
        }
        ,
        'kotlinx.io.node.requireModule' : 
            (require, mod) => {
                 try {
                     let m = require(mod);
                     if (m) return m;
                     return null;
                 } catch (e) {
                     return null;
                 }
            }
        ,
        'com.hyeonslab.prism.demo.consumePendingSceneSwitch' : () => { var v = window.prismNextScene; window.prismNextScene = null; return v || null; },
        'com.hyeonslab.prism.demo.getPbrSceneName' : () => window.prismPbrScene || null,
        'com.hyeonslab.prism.demo.updateFpsDisplay' : (fps) => { var el = document.getElementById('fps-counter'); if (el) el.textContent = fps + ' fps'; },
        'com.hyeonslab.prism.demo.showFatalError' : (msg) => {
          console.error('Prism: ' + msg);
          var canvas = document.getElementById('prismCanvas');
          if (canvas) canvas.style.display = 'none';
          var fallback = document.getElementById('fallback');
          if (fallback) { fallback.style.display = 'block'; fallback.textContent = 'Error: ' + msg; }
        }
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './prism-prism-demo-core.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },


    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject, { builtins: [''] });
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject, { builtins: [''] });
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./prism-prism-demo-core.wasm',import.meta.url).href), importObject, { builtins: [''] })).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
